import { render, staticRenderFns } from "./navigation-drawer.vue?vue&type=template&id=4aaf68a8&scoped=true"
import script from "./navigation-drawer.vue?vue&type=script&lang=js"
export * from "./navigation-drawer.vue?vue&type=script&lang=js"
import style0 from "./navigation-drawer.vue?vue&type=style&index=0&id=4aaf68a8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4aaf68a8",
  null
  
)

export default component.exports